var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 18.758,
    viewBox: "0 0 25 18.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconfinder_code_1608639",
    d: "M-11.186,288.852l-.683.683a.432.432,0,0,1-.314.137.432.432,0,0,1-.314-.137l-6.366-6.366a.432.432,0,0,1-.137-.314.432.432,0,0,1,.137-.314l6.366-6.366a.432.432,0,0,1,.314-.137.432.432,0,0,1,.314.137l.683.683a.432.432,0,0,1,.137.314.432.432,0,0,1-.137.314l-5.369,5.369,5.369,5.369a.432.432,0,0,1,.137.314A.432.432,0,0,1-11.186,288.852Zm8.074-14.577-5.1,17.637a.444.444,0,0,1-.212.266.381.381,0,0,1-.321.034l-.847-.232a.444.444,0,0,1-.266-.212.409.409,0,0,1-.034-.335l5.1-17.637a.444.444,0,0,1,.212-.266.381.381,0,0,1,.321-.034l.847.232a.444.444,0,0,1,.266.212A.409.409,0,0,1-3.112,274.276Zm8.975,8.893L-.5,289.535a.432.432,0,0,1-.314.137.432.432,0,0,1-.314-.137l-.683-.683a.432.432,0,0,1-.137-.314.432.432,0,0,1,.137-.314l5.369-5.369-5.369-5.369a.432.432,0,0,1-.137-.314.432.432,0,0,1,.137-.314l.683-.683a.432.432,0,0,1,.314-.137.432.432,0,0,1,.314.137l6.366,6.366a.43.43,0,0,1,0,.628Z",
    transform: "translate(19 -273.476)",
    fill: "#2699fb"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.7792b6af50048c5efb4841e7ed3e6c53.svg";
export { ForwardRef as ReactComponent };